//
//
//
//
//
//
//
//
//
//

export default {
  name: "Per",
  methods: {
    refresh() {
      this.$router.push("/operate");
    },
  },
};
